/**
 * card wrapper component
 * including number/password/...
 */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {PermissionResourceService} from "../service/resources/permission/permissionResource.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'permission',
    template: `
        <ng-container *ngIf="hasPermission">
            <ng-content select=".has-permission"></ng-content>
        </ng-container>
        <ng-container *ngIf="!hasPermission">
            <ng-content select=".has-no-permission"></ng-content>
        </ng-container>
    `
})
export class PermissionComponent implements OnInit{
    @Input()
    public path: string;

    public hasPermission: boolean;

    private sub: Subscription;

    constructor(private permission: PermissionResourceService, private ref: ChangeDetectorRef) {}

    public ngOnInit(): void {
        this.permission.hasPermission(this.path)
            .subscribe((hasPermission: boolean): void => {
                this.hasPermission = hasPermission;
                this.ref.detectChanges();
            });
    }
}
